import { withTranslation } from "react-i18next"
import { RightOutlined } from '@ant-design/icons'

// Inner
import * as Styled from '../../styled';
import Title from "components/Title";


/**
 * DefaultView
 * @param {*} props 
 * @returns 
 */
const DefaultView = (props) => {

  const getDisabledEnabledColor = () => {
    return props.selectedMount ? 'rgb(83, 182, 186)' : '#b1c7c7'
  }

  return (
    <>
      <Styled.OptionsSelector
        onClick={() => props.setDisplayUserMountsModal(true)}
      >
        <div style={{ width: 50 }}>
          <Title size={16} color="#8d8d8d">1.</Title>
        </div>
        <Title style={{ marginBottom: 20 }} size={16} color="#8d8d8d">Je choisis mon montage à imprimer</Title>
        {
          props.selectedIris.length > 0 && (
            <Styled.IrisBadge>{props.selectedIris.length}</Styled.IrisBadge>
          )
        }
        <RightOutlined style={{ marginLeft: 'auto', marginRight: 10, fontSize: 20 }} />
      </Styled.OptionsSelector>


      <Styled.OptionsSelector
        onClick={() => props.selectedMount ? props.setDisplaySupportsModal(true) : null}
      >
        <div style={{ width: 50 }}>
          <Title size={16} color={getDisabledEnabledColor()}>2.</Title>

        </div>
        <Title style={{ marginBottom: 20 }} size={16} color={getDisabledEnabledColor()}>Je choisis mon support d'impression</Title>
        {
          props.selectedIris.length > 0 && (
            <Styled.IrisBadge>{props.selectedIris.length}</Styled.IrisBadge>
          )
        }
        <RightOutlined style={{ marginLeft: 'auto', marginRight: 10, fontSize: 20 }} />
      </Styled.OptionsSelector>

{/* 

      <Styled.OptionsSelector
        onClick={() => props.selectedIris.length === 0 ? null : props.setView('effect-selection')}
      >
        <div style={{ width: 50 }}>
          <ThunderboltOutlined style={{ fontSize: 20, color: getDisabledEnabledColor() }} />
        </div>
        <Text style={{ marginBottom: 20 }} size={14} color={getDisabledEnabledColor()}>Sélectionnez un effet</Text>
        <RightOutlined style={{ marginLeft: 'auto', marginRight: 10, fontSize: 20, color: getDisabledEnabledColor() }} />
      </Styled.OptionsSelector>

      <Styled.OptionsSelector
        onClick={() => props.setView('mounts')}
      >
        <div style={{ width: 50 }}>
          <HistoryOutlined style={{ fontSize: 20, color: '#53b6ba' }} />
        </div>
        <Text style={{ marginBottom: 20 }} size={14} color={'#53b6ba'}>Vos montages</Text>
        <RightOutlined style={{ marginLeft: 'auto', marginRight: 10, fontSize: 20, color: '#53b6ba' }} />
      </Styled.OptionsSelector> */}

      {/* {
        props.selectedMount && (
          <>
            <Text style={{ paddingTop: 10, marginLeft: 10, marginBottom: 10  }} size={16} color="#53b6ba">Votre sélection</Text>
            <div style={{ justifyContent: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', background: 'black'}}>
              <Image src={`${process.env.REACT_APP_S3_FILES_URL}${props.selectedMount.output}`} width={300} style={{margin: 'auto', marginBottom: 10 }} />
            </div>

            <Styled.OptionsSelector
              onClick={() => props.setView('supports')}
            >
              <div style={{ width: 50 }}>
                <PictureOutlined style={{ fontSize: 20, color: "#53b6ba" }} />
              </div>
              <Text style={{ marginBottom: 20 }} size={14} color={"#53b6ba"}>Sélectionnez un support</Text>
              <RightOutlined style={{ marginLeft: 'auto', marginRight: 10, fontSize: 20, color: "#53b6ba" }} />
            </Styled.OptionsSelector>

            {
              props.selectedSupport && (
                <div style={{ marginTop: 10 }}>
                  <div style={{ display: 'flex', padding: 10 }}>
                    <Text size={13} style={{ marginTop: 5 }}>Prix TTC, hors frais de livraison</Text>
                    <Text size={20} style={{ marginLeft: 'auto' }}>{getTotalPriceForSelectedSupport()}€</Text> 
                  </div>
                  <div style={{ display: 'flex', padding: 10 }}>
                    <Select
                      style={{ width: 100, marginRight: 20 }}
                      size="large"
                      onChange={(val) => setTotalItems(val)}
                      defaultValue={1}
                    >
                      {
                        Array.from(Array(totalCountSelectable).keys()).map((inc) => (
                          <Select.Option value={inc + 1} key={`total-selectable-item-${inc + 1}`}>{inc + 1}</Select.Option>
                        ))
                      }
                    </Select>
                    <Button 
                      type="primary"
                      size="large"
                      style={{ marginLeft: 'auto', width: '100%', marginRight: 10 }}
                      onClick={() => { props.handleAddToBasket({ mount: props.selectedMount, support: props.selectedSupport, quantity: totalItems }); props.setView('basket')}}
                    >
                      Ajouter au panier
                    </Button>
                    <Button type="danger" size="large">X</Button>
                  </div>
                </div>
              )
            }
          </>
        )
      } */}
     
    </>
  )
}

export default withTranslation()(DefaultView)